import { ViewerDocument } from "~/gql/graphql";

export function useViewer() {
	const { isAuthenticated } = useAuth();

	const { result, loading, error, refetch } = useQuery(
		ViewerDocument,
		null,
		() => ({
			enabled: isAuthenticated.value,
			fetchPolicy: "cache-first",
		}),
	);

	const viewer = computed(() => result.value?.viewer ?? null);

	return {
		viewer,
		loading,
		error,
		refetch,
	};
}
